<template>
    <div class="appeal-result">
        <div class="title">{{ documentTitle }}</div>
        <section class="content-sec">
            <div class="sec-title">举报内容</div>
            <div class="content-box sec-box">
                <div
                    class="content-item"
                    v-for="(value, label) in contentMap"
                    :key="label"
                >
                    <label>{{ label }}：</label>
                    <p>{{ value }}</p>
                </div>
            </div>
            
        </section>

        <section class="result-sec" v-if="result">
            <div class="sec-title">受理结果</div>
            <div class="result-box sec-box">
                <label>{{ result.title }}</label>
                <p>{{ result.text }}</p>
            </div>
            <div class="result-appeal">
                <div class="appeal-btn" v-if="allowAppeal" @click="jumpToAppeal">我要申诉<i class="arrow"/></div>
            </div>
        </section>

    </div>
</template>

<script>
import { Toast, Bxios } from '@bplus-common/components-vue2'
import BiliUser from '@bilibili/bili-user'

const CONTENT_KEY = {
    ROW: '评论原文',
    REASON: '举报理由',
}
export default {
    props: {
        params: Object
    },
    data() {
        return {
            userInfo: null,
            roleType: 1,
            contentMap: {
                [CONTENT_KEY.ROW]: '-',
                [CONTENT_KEY.REASON]: '-',
            },
            result: null,
            allowAppeal: false,
        }
    },
    computed: {
        documentTitle() {
            return this.roleType === 1 ? '举报详情页' : '评论违规处理结果'
        },
    },
    async created() {
        this.roleType = this.params.roleType
        document.title = this.documentTitle

        try {
            const { code, data } = await BiliUser.get()
            if (code === 0) {
                this.userInfo = data
            } else {
                return
            }
        } catch {
            Toast('请先登录')
            return
        }
        try {
            const data = await Bxios({
                method: 'GET',
                url: '/x/v2/reply/report/result',
                baseURL: Bxios.BASE_URL.API,
                params: {
                    rpid: this.params.replyId,
                    report_reason: this.params.reportReason,
                    audit_result: this.params.auditResult, 
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
            })
            this.contentMap[CONTENT_KEY.ROW] = data.report_content?.reply_raw_message
            this.contentMap[CONTENT_KEY.REASON] = data.report_content?.report_reason_desc
            this.result = data.report_result
            this.allowAppeal = data.appeal?.allow_appeal || false
        } catch (err) {
            Toast(err.message || '')
        }
        return
    },
    methods: {
        jumpToAppeal() {
            location.href = `//${location.host}${location.pathname}`
        },
    },
}
</script>

<style lang="less">
.appeal-result {
    padding-top: 30px;
    padding-bottom: 24px;
    width: 420px;
    margin: 0 auto;
    section {
        padding-bottom: 36px;
        &.content-sec {
            margin-top: 14px;
            padding-top: 14px;
            border-top: 1px solid #E5E9EF;
        }
    }
    .title {
        font-weight: 700;
        font-size: 22px;
        line-height: 34px;
        text-align: center;
    }
    .sec-title {
        font-size: 16px;
        line-height: 22px;
        color: #9499A0;
        margin-bottom: 12px;
    }
    .sec-box {
        background: #F6F7F8;
        border-radius: 4px;
        padding: 12px;
        .content-item {
            display: flex;
            label {
                flex-shrink: 0;
            }
            p {
                flex: 1;
                margin-top: -2px;
                max-height: 120px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                word-break: break-all;
                -webkit-line-clamp: 5;
                /*! autoprefixer: ignore next */
                -webkit-box-orient: vertical;
            }
        }
    }
    label {
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: #18191C;
    }
    p {
        font-size: 14px;
        line-height: 24px;
        color: #61666D;
    }
    .result-appeal {
        margin-top: 12px;
        display: flex;
    }
    .appeal-btn {
        user-select: none;
        cursor: pointer;
        margin-left: auto;
        height: 18px;
        display: flex;
        align-items: center;
        font-size: 13px;
        color: #9499A0;
;
        .arrow {
            width: 12px;
            height: 12px;
            background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAZCAYAAAArK+5dAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADVSURBVHgB7ZXBDcIwDEW/A4N0FTZghOaCVPWAmACWQD22m8AIHaGD0ISmFE5BsZ0DEuo/xZL1nuTECrDm16FUQ9O0xcOg3Dp0VWUHCGNSDaPBhUDn0dAtyCBMUkAO9+VYaCTJEYVcm7b0htqlHDbO77jjYglyJGyBViISaCRigVSiEkgkyWf6LXVlO8CflnJ6wtjH+tSC1z7Q8V0TffYlXxDgYemmYzHDnbf1wfaxXvEdROHzuOIRCaRwkUADZwu0cJYgBx7C+g+0cJZg/g8IvQb+H3kCfUSM6Y4r2q8AAAAASUVORK5CYII=) center / cover no-repeat;
        }
    }
}
</style>